import type { ComponentColour, ComponentType } from '../../gql';

import { randBoolean } from '@ngneat/falso';

import { mockMasterColour } from '../mockMasterColour';

export const mockComponentColour = (
    type: ComponentType,
    overwrite?: Partial<ComponentColour>
): ComponentColour => ({
    type,
    isDyedToMatch: randBoolean(),
    masterColour: randBoolean() ? mockMasterColour() : undefined,
    ...overwrite,
    ['__typename']: 'ComponentColour',
});
